import { render, staticRenderFns } from "./button-print-ticket.vue?vue&type=template&id=1bee2897"
import script from "./button-print-ticket.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-print-ticket.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1205356875/src/github.com/growmark/energy-llc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bee2897')) {
      api.createRecord('1bee2897', component.options)
    } else {
      api.reload('1bee2897', component.options)
    }
    module.hot.accept("./button-print-ticket.vue?vue&type=template&id=1bee2897", function () {
      api.rerender('1bee2897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vendor/src/components/button-print-ticket.vue"
export default component.exports